const pageResume = fn => {
  try {
    document.addEventListener('pageResume', event => {
      fn(event);
    }, false);
  } catch (e) {}
};
export default pageResume;